import { useState } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { common, financedEmissions } from "../../../i18n";
import { TabMenu, TabMenuData } from "../../../components/tabMenu/TabMenu";
import GenerateTab from "./GenerateTab";
import HistoryTab from "./HistoryTab";

type Tab = "generate" | "history";

const Report = () => {
  const { t } = useTranslation([financedEmissions, common], {
    nsMode: "fallback",
  });
  const [tab, setTab] = useState<Tab>("generate");

  const tabs: TabMenuData[] = [
    { pathname: "generate", name: "Report-Generate", label: t("Report-Generate") },
    { pathname: "history", name: "Report-History", label: t("Report-History") },
  ];

  return (
    <Box display="flex" flexDirection="column" gap="20px">
      <TabMenu
        type="underline"
        tabMenuData={tabs}
        value={tab}
        onChange={(k) => setTab(k as Tab)}
      />
      {tab === "generate" ? <GenerateTab /> : <HistoryTab />}
    </Box>
  );
};

export default Report;
